/* Soft Stacks Co. — theme behaviour */
(function () {
  var cfg = window.SoftStacks || {};
  var routes = cfg.routes || {};

  /* ---------- utilities ---------- */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function toast(message) {
    var host = $('#ToastHost');
    if (!host) return;
    var el = document.createElement('div');
    el.className = 'toast';
    el.textContent = message;
    host.appendChild(el);
    setTimeout(function () { el.remove(); }, 3200);
  }

  function formatMoney(cents) {
    var fmt = cfg.moneyFormat || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/, whole + '.' + parts[1])
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, whole)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1])
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.'));
  }
  window.SoftStacks.formatMoney = formatMoney;

  /* ---------- reveal on scroll ---------- */
  function initReveal() {
    var els = $$('.reveal:not(.is-visible)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- drawers ---------- */
  function openEl(el, overlayName) {
    if (!el) return;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    var overlay = document.querySelector('[data-overlay="' + overlayName + '"]');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeEl(el, overlayName) {
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    var overlay = document.querySelector('[data-overlay="' + overlayName + '"]');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  var cartDrawer = function () { return $('#CartDrawer'); };
  var mobileMenu = function () { return $('#MobileMenu'); };

  function openCart() { openEl(cartDrawer(), 'cart'); }
  function closeCart() { closeEl(cartDrawer(), 'cart'); }
  window.SoftStacks.openCart = openCart;

  /* ---------- cart ---------- */
  function refreshCart(open) {
    return fetch(routes.cart + '?section_id=cart-drawer', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var body = $('#CartDrawerBody');
        if (body) body.innerHTML = html;
        return fetch(routes.cart + '.js', { headers: { 'Accept': 'application/json' } });
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
        if (open) openCart();
        return cart;
      })
      .catch(function (err) { console.error('Cart refresh failed', err); });
  }

  function addToCart(items, opts) {
    opts = opts || {};
    return fetch(routes.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) {
          toast(res.data.description || res.data.message || 'Could not add to bag');
          return null;
        }
        if (opts.message !== false) toast(opts.message || 'Added to your bag');
        return refreshCart(opts.open !== false);
      })
      .catch(function () { toast('Could not add to bag'); });
  }
  window.SoftStacks.addToCart = addToCart;

  function changeLine(line, quantity) {
    return fetch(routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function () { return refreshCart(false); })
      .then(function () {
        if (document.body.classList.contains('template-cart')) window.location.reload();
      });
  }

  /* ---------- predictive search ---------- */
  var searchTimer;
  function runSearch(term) {
    var results = $('#SearchResults');
    if (!results) return;
    if (!term.trim()) { results.innerHTML = ''; return; }
    fetch(routes.predictiveSearch + '?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=6&section_id=predictive-search')
      .then(function (r) { return r.text(); })
      .then(function (html) { results.innerHTML = html; })
      .catch(function () { results.innerHTML = ''; });
  }

  /* ---------- delegated events ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;

    if (t.closest('.js-cart-open')) { e.preventDefault(); refreshCart(true); return; }
    if (t.closest('.js-cart-close')) { closeCart(); return; }
    if (t.closest('.js-menu-open')) { openEl(mobileMenu(), 'menu'); return; }
    if (t.closest('.js-menu-close')) { closeEl(mobileMenu(), 'menu'); return; }

    if (t.closest('.js-search-open')) {
      e.preventDefault();
      var modal = $('#SearchModal');
      if (modal) { modal.classList.add('is-open'); var input = $('#SearchInput'); if (input) input.focus(); }
      return;
    }
    if (t.closest('.js-search-close') || (t.id === 'SearchModal')) {
      var m = $('#SearchModal');
      if (m) m.classList.remove('is-open');
      return;
    }

    var quick = t.closest('.js-quick-add');
    if (quick) {
      e.preventDefault();
      var id = quick.getAttribute('data-variant-id');
      if (!id) return;
      quick.disabled = true;
      addToCart([{ id: Number(id), quantity: 1 }]).then(function () { quick.disabled = false; });
      return;
    }

    var qty = t.closest('.js-qty');
    if (qty) {
      e.preventDefault();
      changeLine(Number(qty.getAttribute('data-line')), Number(qty.getAttribute('data-qty')));
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeCart();
    closeEl(mobileMenu(), 'menu');
    var m = $('#SearchModal');
    if (m) m.classList.remove('is-open');
  });

  document.addEventListener('input', function (e) {
    if (e.target && e.target.id === 'SearchInput') {
      clearTimeout(searchTimer);
      var val = e.target.value;
      searchTimer = setTimeout(function () { runSearch(val); }, 250);
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();

    /* sticky add-to-cart on product pages */
    var sticky = $('.sticky-atc');
    var form = $('#ProductForm');
    if (sticky && form && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          sticky.classList.toggle('is-visible', !entry.isIntersecting);
        });
      }, { threshold: 0 });
      io.observe(form);
    }
  });

  window.SoftStacks.initReveal = initReveal;
  window.SoftStacks.toast = toast;
  window.SoftStacks.refreshCart = refreshCart;
})();
